import { render, staticRenderFns } from "./MassSendCustomer.vue?vue&type=template&id=79150255&scoped=true&"
import script from "./MassSendCustomer.vue?vue&type=script&lang=js&"
export * from "./MassSendCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79150255",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79150255')) {
      api.createRecord('79150255', component.options)
    } else {
      api.reload('79150255', component.options)
    }
    module.hot.accept("./MassSendCustomer.vue?vue&type=template&id=79150255&scoped=true&", function () {
      api.rerender('79150255', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/MassSendCustomer/MassSendCustomer.vue"
export default component.exports